import { useCallback } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { NOT_ENROLLED, getExperimentCohort } from './feature-flag';

export type IneligibilityReasons =
	| 'NO_COLLABORATORS_FOUND'
	| 'COLLABORATORS_ALREADY_HAVE_ACCESS_TO_LINK'
	| 'COLLABORATORS_HAVE_NO_ACCESS_TO_SPACE'
	| 'COLLABORATORS_HAVE_NO_ACCESS_TO_PAGE'
	| 'NOT_ELIGIBLE_FOR_INVITE'
	| 'ELIGIBLE';

export const useFeatureExposed = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return useCallback(
		(ineligibilityReason: IneligibilityReasons) => {
			const isEligible = ineligibilityReason === 'ELIGIBLE';
			const cohort = isEligible ? getExperimentCohort({ fireExposure: true }) : NOT_ENROLLED;
			createAnalyticsEvent({
				type: 'sendTrackEvent',
				data: {
					action: 'exposed',
					actionSubject: 'feature',
					source: 'inviteOnLinkInsert',
					attributes: {
						flagKey: 'invite_on_link_insert_v4-2',
						cohort,
						ineligibilityReason,
					},
				},
			}).fire();
		},
		[createAnalyticsEvent],
	);
};
